import { render, staticRenderFns } from "./IconClone.vue?vue&type=template&id=2292188c&scoped=true&lang=pug&"
import script from "./IconClone.vue?vue&type=script&lang=js&"
export * from "./IconClone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2292188c",
  null
  
)

export default component.exports